import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function TrendingUp(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M3 17h2v-7l6 6 7-13 2 1-8 15-7-7-3 5z" />
    </SvgIcon>
  )
}
